import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography } from '@material-ui/core';

/**
 * The purpose of this component is to conditionaly render Spinner or component that
 * is using data based on isLoading value.
 * Also with it's help you can cover "no data" case by showing user appropriate text.
 */

const LoadingContainer = ({ isLoading, children, isEmpty, emptyStateText, classes }) => {
  if (isLoading) {
    return (
      <div className={classes.root}>
        <CircularProgress className={classes.loader} />
      </div>
    );
  }
  if (isEmpty) {
    return (
      <div className={classes.root}>
        <Typography className={classes.empty}>{emptyStateText}</Typography>
      </div>
    );
  }

  return children;
};

LoadingContainer.propTypes = {
  /** Classes from corresponding .styles.js file */
  classes: PropTypes.shape({}),
  /** Shows Loading animation when true */
  isLoading: PropTypes.bool.isRequired,
  /** Shows text for no data case when true */
  isEmpty: PropTypes.bool,
  /** Text for no data case */
  emptyStateText: PropTypes.string,
  /** Component that is going to be conditionaly rendered */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

LoadingContainer.defaultProps = {
  classes: {},
  isEmpty: false,
  emptyStateText: 'No data',
};

export default LoadingContainer;
